import req from './request'

const DEFAULT_ENDPOINTS = {
    accounts: '/dashboard/accounts',
    accountsSummary: '/dashboard/accounts/summary',
    accountsReport: '/dashboard/accounts/report',
    accountsSnapshots: '/snapshots',
    overview: '/dashboard/overview',
    overviewV2: '/dashboard/overview/v2',
    overviewV2Registry: '/dashboard/overview/v2/registry',
    activeDriver: '/dashboard/active-driver',
    commission: '/dashboard/commission',
    diffCcommission: '/dashboard/diff-commission',
    driving: '/dashboard/driving',
    ordersDriver: '/dashboard/orders-driver',
    parks: '/dashboard/parks',
    payments: '/dashboard/payments',
    registration: '/dashboard/registration',
    replenishment: '/dashboard/replenishment',
}

export default {
    accounts(payload, config) {
        return req.get(payload, DEFAULT_ENDPOINTS.accounts, undefined, undefined, config)
    },
    accountsSummary(payload, config) {
        return req.get(payload, DEFAULT_ENDPOINTS.accountsSummary, undefined, undefined, config)
    },
    accountsReport(payload, config) {
        return req.get(payload, DEFAULT_ENDPOINTS.accountsReport, undefined, undefined, config)
    },
    accountsSnapshots(id, payload, config) {
        return req.get(payload, DEFAULT_ENDPOINTS.accounts, `/${id}${DEFAULT_ENDPOINTS.accountsSnapshots}`, undefined, config)
    },
    overview(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.overview, param)
    },
    overviewV2(payload, param, method, config) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.overviewV2, param, undefined, config)
    },
    overviewV2Registry(payload, param, method, config) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.overviewV2Registry, param, undefined, config)
    },
    activeDriver(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.activeDriver, param)
    },
    commission(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.commission, param)
    },
    diffCcommission(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.diffCcommission, param)
    },
    driving(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driving, param)
    },
    ordersDriver(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.ordersDriver, param)
    },
    parks(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parks, param)
    },
    payments(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.payments, param)
    },
    registration(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.registration, param)
    },
    replenishment(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.replenishment, param)
    }
}

